<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <LiveShare :openModal="openModal" @closeModal="closeModal()" :data="id" />
    <vx-card>
      <template slot="no-body">
        <div class="p-2 flex flex-row justify-between">
          <p class="text-white">_</p>
          <!-- <vs-switch color="success" v-model="active_geofence">
            <span slot="on">Geofence On </span>
            <span slot="off">Geofence Off </span>
          </vs-switch> -->
          <vs-button color="danger" class="p-2" @click="openModal = true">
            <div class="flex flex-row-reverse items-center">
              <feather-icon icon="Share2Icon" svgClasses="w-5 h-5" />
              <p class="mr-2">Share</p>
            </div>
          </vs-button>
        </div>

        <vs-divider style="margin: 0" />
        <vs-row vs-w="12">
          <div class="heights shadow">
            <div
              class="pick-category"
              :class="{ collapse: collapse }"
              style="top: 97px">
              <div
                @click="collapse = !collapse"
                style="
                  padding-top: 6px;
                  padding-bottom: 7px;
                  border-radius: 25px 25px 0 0;
                  background: white;
                ">
                <img
                  :src="POI"
                  style="width: 70%; margin: auto; cursor: pointer"
                  alt="" />
              </div>
              <div class="" v-for="list in categoryPOI" v-if="list.tampil">
                <vx-tooltip
                  :text="
                    disableImage
                      ? 'Please Zoom closer to activate'
                      : list.catpoi_name
                  "
                  position="right"
                  delay=".1s">
                  <img
                    @click="
                      disableImage
                        ? getNothing()
                        : getPOI(list.id, baseUrl + list.marker)
                    "
                    :src="baseUrl + list.images"
                    alt=""
                    :class="{
                      'disable-img': disableImage,
                      'active-icon': list.active_poi,
                    }"
                    class="poi-icon" />
                </vx-tooltip>
              </div>
              <div @click="collapse = !collapse" class="hide-btn">X</div>
            </div>
            <span></span>
            <GmapMap
              ref="mapRef"
              :center="center"
              style="width: 100%; height: 100%"
              :options="{
                mapTypeControlOptions: mapTypeControlOptions,
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
              }">
              <gmap-info-window
                v-if="selectedPOI !== null"
                :options="{ pixelOffset: { width: 0, height: -35 } }"
                :position="{
                  lat: selectedPOI.coordinate.coordinates[1],
                  lng: selectedPOI.coordinate.coordinates[0],
                }"
                :opened="infoBoxPOI"
                @closeclick="infoBoxPOI = false">
                <div
                  class="infoWindow info_container vs-con-loading__container"
                  style="width: 400px">
                  <vs-row vs-w="12">
                    <vs-col
                      vs-justify="center"
                      vs-align="center"
                      vs-lg="12"
                      vs-sm="12"
                      vs-xs="12">
                      <h5>{{ selectedPOI.name }}</h5>
                      <table style="width: 100%">
                        <!--<tr>-->
                        <!--<td>Name</td><td>:</td><td class="bold">{{selectedPOI.name}}</td>-->
                        <!--</tr>-->
                        <tr v-if="selectedPOI.brand != ''">
                          <td>Brand</td>
                          <td>:</td>
                          <td class="bold">{{ selectedPOI.brand }}</td>
                        </tr>
                        <!--<tr v-if="selectedPOI.vmd!=''">-->
                        <!--<td>VMD</td><td>:</td><td class="bold">{{selectedPOI.vmd}}</td>-->
                        <!--</tr>-->
                        <tr>
                          <td>Latitude</td>
                          <td>:</td>
                          <td class="bold">{{ selectedPOI.latitude }}</td>
                        </tr>
                        <tr>
                          <td>Longitude</td>
                          <td>:</td>
                          <td class="bold">{{ selectedPOI.longitude }}</td>
                        </tr>
                        <tr>
                          <td>Type</td>
                          <td>:</td>
                          <td class="bold">{{ selectedPOI.type }}</td>
                        </tr>
                        <tr v-if="selectedPOI.type === 'Specific'">
                          <td>Fleet Group</td>
                          <td>:</td>
                          <td class="bold">
                            {{ selectedPOI.fleet_group_name }}
                          </td>
                        </tr>
                        <tr v-if="selectedPOI.phone != ''">
                          <td>Phone</td>
                          <td>:</td>
                          <td class="bold">{{ selectedPOI.phone }}</td>
                        </tr>
                        <tr v-if="selectedPOI.operating_time != ''">
                          <td>Operating Time</td>
                          <td>:</td>
                          <td class="bold">{{ selectedPOI.operating_time }}</td>
                        </tr>
                        <tr>
                          <td>Address</td>
                          <td>:</td>
                          <td class="bold">{{ selectedPOI.address }}</td>
                        </tr>
                        <tr>
                          <td>Location</td>
                          <td>:</td>
                          <td>
                            <strong>
                              <a
                                target="_blank"
                                :href="
                                  'http://www.google.com/maps/place/' +
                                  selectedPOI.latitude +
                                  ',' +
                                  selectedPOI.longitude
                                "
                                >Show Google Map</a
                              >
                            </strong>
                          </td>
                        </tr>
                      </table>
                    </vs-col>
                  </vs-row>
                  <!--<vs-button  @click="playBack()" class="mt-4 ml-2 shadow float-left" type="gradient" color="#d23030" gradient-color-secondary="#f89595">Play Back</vs-button>-->
                </div>
              </gmap-info-window>
              <GmapPolygon> </GmapPolygon>
            </GmapMap>
          </div>
        </vs-row>
      </template>
    </vx-card>
    <!--<vs-button class="mr-3 mb-2" @click="submitForm" >Get Data</vs-button>-->
  </div>
</template>

<script>
import { BASE_FILE } from '../../constant'
import POI from '../../assets/images/POI.svg'
import firebase from 'firebase/app'
import { socket } from '@/socket'

const car =
  'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
import 'firebase/database'
import * as REPO from '../../repository/index'
import { gmapApi } from 'vue2-google-maps'
import moment, { duration } from 'moment'

import LiveShare from '../components/LiveShare.vue'

export default {
  props: {
    data_s: Object,
    categoryPOI: Array,
    dataSubscribe: Array,
    license_plate: String,
  },
  components: {
    LiveShare,
  },
  data() {
    return {
      openModal: false,
      pesan: '',
      userFirebase: null,
      googleListener: null,
      reff: null,
      sub_success: false,
      POI: POI,
      CrashColor: '#c42f26',
      IdleColor: '#4e4e4e',
      StopColor: '#000000',
      SilenceColor: '#ce6f1b',
      MovingColor: '#398d3a',
      center: { lat: -6.1498619, lng: 106.882887 },
      location_list: [],
      map: null,
      directionDisplay: '',
      selectedPOI: null,
      directionsService: '',
      selectedLocation: '',
      baseUrl: '',
      stepDisplay: '',
      active_geofence: true,
      collapse: true,
      selectedPOICategory: null,
      current_zoom: null,
      disableImage: true,
      infoBoxPOI: false,
      lastStep: 50,
      position: '',
      eol: '',
      speed2: '',
      id: '',
      mapTypeControlOptions: {
        mapTypeIds: [],
      },
      icon: {},
      polygon: [],
      dataPOI: [],
      // dataSubscribe:'',
      lastVertex: 1,
      stepnum: 0,
      car: 'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z',
      step: 50,
      tick: 5,
      k: 0,
      kmStep: 0,
      baseSpeed: 25,
      polyline: null,
      speed: 0.000005,
      wait: 1,
      poly2: null,
      infowindow: null,
      timerHandle: null,
      marker: null,
      markerArray: [],
      steps: [],

      dataIndex: 0,
      data_jadi_tmp: {},
      data_jadi_arr: [],
      isMoving: false,
      pollingInterval: null,
    }
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    data_jadi_arr: function (val) {},
    data_s: function (val) {
      let self = this
      setTimeout(() => {
        if (val) {
          const currentItem =
            self.data_jadi_tmp.anchors[self.data_jadi_tmp.anchors.length - 1]
          const nextItem = val
          self.data_jadi_tmp.anchors.push(nextItem)

          const duration =
            (new Date(nextItem.device_time).getTime() -
              new Date(currentItem.device_time).getTime()) /
            1000

          const speed =
            google.maps.geometry.spherical.computeDistanceBetween(
              new google.maps.LatLng(
                currentItem.latitude,
                currentItem.longitude
              ),
              new google.maps.LatLng(nextItem.latitude, nextItem.longitude)
            ) / duration
          self.data_jadi_tmp.duration = duration
          self.data_jadi_tmp.speed = speed
          // const before = self.data_jadi_arr
          //
          self.data_jadi_tmp = {
            anchors: [nextItem],
            speed: null,
            duration: null,
          }
          self.data_jadi_arr.push(self.data_jadi_tmp)
          //

          async function processRoutes(index) {
            // if (index < index + 2) {
            var waypoints = []
            const parts = [
              {
                lat: self.data_jadi_arr[index].anchors[0].latitude,
                lng: self.data_jadi_arr[index].anchors[0].longitude,
              },
              {
                lat: self.data_jadi_arr[index].anchors[1].latitude,
                lng: self.data_jadi_arr[index].anchors[1].longitude,
              },
            ]
            for (var j = 0; j < parts.length - 1; j++) {
              waypoints.push({ location: parts[j], stopover: false })
            }
            //

            var service_options = {
              origin: new google.maps.LatLng(parts[0].lat, parts[0].lng),
              destination: new google.maps.LatLng(parts[1].lat, parts[1].lng),
              // waypoints: waypoints,
              travelMode: 'DRIVING',
            }

            try {
              const response = await new Promise((resolve, reject) => {
                self.directionsService.route(
                  service_options,
                  (response, status) => {
                    if (status === 'OK') {
                      resolve(response)
                    } else {
                      reject(
                        new Error(
                          `Directions request failed with status: ${status}`
                        )
                      )
                    }
                  }
                )
              })

              self.directionsDisplay.setMap(self.map)
              self.directionsDisplay.setOptions({
                suppressMarkers: true,
                preserveViewport: true,
              })
              self.directionsDisplay.setDirections(response)

              var bounds = new google.maps.LatLngBounds()
              var route = response.routes[0]
              // update dataGroup distance based on route distance (distance between origin and destination)
              self.data_jadi_arr[index].distance = route.legs[0].distance.value
              self.startLocation = {}
              self.endLocation = {}

              for (var i2 = 0; i2 < route.legs.length; i2++) {
                if (index === 0) {
                  self.startLocation.latlng = route.legs[i2].start_location
                  self.startLocation.address = route.legs[i2].start_address
                }
                self.endLocation.latlng = route.legs[i2].end_location
                self.endLocation.address = route.legs[i2].end_address

                var steps = route.legs[i2].steps
                for (var j = 0; j < steps.length; j++) {
                  var nextSegment = steps[j].path
                  for (var k = 0; k < nextSegment.length; k++) {
                    self.polyline.getPath().push(nextSegment[k])
                    bounds.extend(nextSegment[k])
                  }
                }
              }

              self.polyline.setMap(self.map)
              self.map.fitBounds(bounds)
              self.map.setZoom(17)
              self.startAnimation()
            } catch (error) {
              console.error('Error processing route:', error)
              // Handle error as needed
            }
            // }
          }

          if (
            !self.isMoving &&
            self.data_jadi_arr.length - self.dataIndex >= 2
          ) {
            // make moving animation here
            //

            self.isMoving = true
            // self.polyline.setMap(null)
            self.polyline = new google.maps.Polyline({
              path: [],
              strokeColor: '#78a4ff',
              strokeWeight: 3,
            })
            var rendererOptions = {
              polylineOptions: {
                strokeColor: '#78a4ff',
              },
              map: self.map,
            }
            self.directionsService = new google.maps.DirectionsService()
            self.directionsDisplay = new google.maps.DirectionsRenderer(
              rendererOptions
            )

            // Start processing routes
            processRoutes(self.dataIndex)
            if (self.data_jadi_arr.length == 1) {
              // stop animation
              self.isMoving = false
            }
          }
        }
      }, 1000)
    },
    '$route.params.id': function (val) {
      this.navigateHandler()
      this.$vs.loading({
        container: '#data-list-list-view',
        scale: 1,
      })
      setTimeout(() => {
        // this.reSubscribe()
      }, 300)
    },
    active_geofence(val) {
      //
      if (val == true) {
        if (this.dataSubscribe != '') {
          this.dataSubscribe.forEach((poli) => {
            if (poli.type != 'CIRCLE') {
              let poly = []

              let coor = poli.geofence_detail.coordinates[0]
              coor.forEach((x) => {
                let tmp = new google.maps.LatLng(x[1], x[0])
                poly.push(tmp)
              })
              let tmo = new google.maps.Polygon({
                path: poly,
                draggable: false,
                editable: false,
                strokeColor: poli.colour,
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: poli.colour,
                fillOpacity: 0.35,
                map: this.map,
              })
              this.polygon.push(tmo)
            } else {
              let coor = poli.geofence_detail.coordinates
              let center = {
                lat: coor[1],
                lng: coor[0],
              }

              let color = '#FF0000'
              if (poli.colour != '') {
                color = poli.colour
              }
              this.drawingManager = new google.maps.Circle({
                strokeColor: color,
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: color,
                fillOpacity: 0.35,
                map: this.map,
                center: center,
                radius: poli.radius,
              })
            }
          })
        }
      } else {
        this.polygon.forEach((x) => {
          x.setMap(null)
        })
      }
    },
  },
  created() {
    var self = this
    this.id = this.$route.params.id

    self.data_jadi_tmp = {
      anchors: [self.data_s],
      speed: null,
      duration: null,
    }
    this.baseUrl = BASE_FILE.substring(0, BASE_FILE.length - 4)
    // document.addEventListener('beforeunload', this.CloseHandler)
    // window.addEventListener('beforeunload', function (event) {
    //     self.reff.off();
    //     REPO.unsubscribeVehicle(self.id);
    // }, false)
    window.onbeforeunload = () => {
      //
      //
      let alamat = this.$route.name
      if (alamat == 'monitoringView') {
        self.closeHandler()

        return 'Some task is in progress. Are you sure, you want to close?'
      } else {
        return undefined
      }
      // setTimeout(()=>{
      //     this.subscribe();
      // },5000);
      // if (this.$route.name === 'monitoringView') {
      //
      //
      // }
    }
  },
  beforeDestroy() {
    this.navigateHandler()
    //
    // clear all animation

    // REPO.unsubscribeVehicle(this.$route.params.id);
    //
    // Hentikan polling saat komponen dihancurkan
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
      this.pollingInterval = null
    }
  },
  methods: {
    async fetchVehiclePosition() {
      try {
        const res = await REPO.getLastPositionAuth(this.id)
        if (res.data.status !== 'true') return
        const data = res.data.data
        // Update posisi dan arah marker mobil
        const pos = new google.maps.LatLng(data.latitude, data.longitude)
        if (!this.marker) {
          this.marker = new google.maps.Marker({
            position: pos,
            map: this.map,
            // ...icon dan options lain...
          })
        } else {
          this.marker.setPosition(pos)
        }
        this.map.setCenter(pos)
      } catch (err) {
        console.error('Error fetching vehicle position:', err)
      }
    },
    postAnimation() {
      let data_s = this.data_s
      self.selectedLocation = this.data_s
      let data_ = {
        lat: data_s.latitude,
        lng: data_s.longitude,
        vehicle_activity: data_s.vehicle_activity,

        direction: data_s.direction,
        speed: data_s.speed,
      }

      let diff_time = moment.duration(moment().diff(data_s.device_time))
      let hours = diff_time.asHours()
      let warna = this.SilenceColor
      if (parseFloat(hours) >= 4 || data_s.vehicle_activity == 'SILENCE') {
        warna = this.SilenceColor
      } else if (data_s.vehicle_activity == 'CRASH') {
        warna = this.CrashColor
      } else if (data_s.vehicle_activity == 'MOVING') {
        warna = this.MovingColor
      } else if (data_s.vehicle_activity == 'IDLE') {
        warna = this.IdleColor
      } else if (data_s.vehicle_activity == 'STOP') {
        warna = this.StopColor
      }
      // self.location_list.push(data_)
      // if (self.location_list.length > 0) {
      //   let panjang = self.location_list.length
      //   //
      //   let lokk = new google.maps.LatLng(
      //     self.location_list[panjang - 1].lat,
      //     self.location_list[panjang - 1].lng
      //   )

      //   self.icon.rotation = self.location_list[panjang - 1].direction
      //   if (self.marker == null) {
      //     self.map.setCenter(lokk)
      //     self.marker = new google.maps.Marker({
      //       position: lokk,
      //       map: self.map,
      //       icon: self.icon,
      //     })
      //   } else {
      //     // self.map.setCenter(lokk);
      //     self.marker.setPosition(lokk)
      //     self.icon.rotation = self.location_list[panjang - 1].direction
      //     self.icon.fillColor = warna
      //     self.marker.setIcon(self.icon)
      //   }
      // }
    },
    closeModal() {
      this.openModal = false
    },
    delay(fn, ms) {
      let timer = 0
      return function (...args) {
        clearTimeout(timer)
        timer = setTimeout(fn.bind(this, ...args), ms || 0)
      }
    },
    getNothing() {},
    getPOI(code, marker) {
      this.$vs.loading({
        container: '#data-list-list-view',
        scale: 1,
      })
      let ada = this.dataPOI
      // let ada = this.dataPOI.filter(z=>{
      //     return z.id == code;
      // });
      let cat = this.categoryPOI.filter((z) => {
        return z.id == code
      })

      if (cat[0].active_poi) {
        this.selectedPOICategory = null
        cat[0].active_poi = false
        if (ada.length > 0) {
          if (ada[0].poi.length > 0) {
            ada[0].poi.forEach((x) => {
              x.setMap(null)
            })
          }
          ada[0].poi = []
        }

        let aktif = this.categoryPOI.filter((z) => {
          return z.active_poi == true
        })
        if (aktif.length == 0) {
          this.map.setOptions({
            styles: [
              {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [{ visibility: 'on' }],
              },
            ],
          })
        }
        setTimeout(() => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        }, 200)
      } else {
        this.selectedPOICategory = {
          id: code,
          marker: marker,
        }
        this.categoryPOI.forEach((z) => {
          z.active_poi = false
        })
        if (ada.length > 0) {
          if (ada[0].poi.length > 0) {
            ada[0].poi.forEach((x) => {
              x.setMap(null)
            })
          }
          ada[0].poi = []
        }

        cat[0].active_poi = true
        this.map.setOptions({
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
          ],
        })
        if (ada.length > 0) {
          // setTimeout(()=>{
          //
          //     this.$vs.loading.close('#data-list-list-view > .con-vs-loading');
          // },200)
          // this.tampilPOI(ada[0].data, marker, code);
          REPO.getPOIParam({
            coordinates: this.data_coordinate,
            category_poi_id: code,
            type: 'General',
          })
            .then((res) => {
              let tmp = {
                id: code,
                status: true,
                poi: [],
                data: res.data.data,
              }
              this.dataPOI = []
              this.dataPOI.push(tmp)
              this.tampilPOI(tmp.data, marker, code)
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
            .catch((err) => {
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
        } else {
          let tmp = JSON.parse(JSON.stringify(this.data_coordinate))

          REPO.getPOIParam({
            coordinates: tmp,
            category_poi_id: code,
            type: 'General',
          })
            .then((res) => {
              let tmp = {
                id: code,
                status: true,
                poi: [],
                data: res.data.data,
              }
              this.dataPOI = []
              this.dataPOI.push(tmp)
              this.tampilPOI(tmp.data, marker, code)
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
            .catch((err) => {
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
        }
      }
      this.categoryPOI.push({
        tampil: false,
      })
    },
    tampilPOI(data, marker, code) {
      var self = this
      let ada = this.dataPOI

      if (ada[0].poi.length > 0) {
        ada[0].poi.forEach((x) => {
          x.setMap(null)
        })
      }
      ada[0].poi = []

      data.forEach(function (location, i) {
        //
        if (location.coordinate.coordinates.length > 0) {
          let loc = {
            lat: location.coordinate.coordinates[1],
            lng: location.coordinate.coordinates[0],
          }

          let pilih_marker = marker
          let icon = {
            url: pilih_marker + '#1',
            anchor: new google.maps.Point(9, 24),
            scaledSize: new google.maps.Size(18, 18),
            labelOrigin: new google.maps.Point(9, -5),
            fillColor: '#00CCBB',
            fillOpacity: 1,
            strokeColor: '',
            strokeWeight: 0,
          }
          //
          let mark = new google.maps.Marker({
            position: loc,
            // label:{
            //     color: 'blue', // <= HERE
            //     fontSize: '10px',
            //     fontWeight: '900',
            //     text: location.name
            // },
            map: self.map,
            icon: icon,
          })
          // google.maps.event.addListener(mark, 'click', ()=> {
          //     self.infowindow.setContent("<div>" +
          //         "<span></span>" +
          //         "<hr>" +
          //         "<button class='btn btn-primary' @click='viewDetail2(tes cluster)'>View Detail</button>" +
          //         "</div>");
          //     self.infowindow.open(map, mark);
          // });
          google.maps.event.addListener(mark, 'click', () => {
            self.center = loc

            //
            // self.$vs.loading();
            self.selectedPOI = location
            self.infoBoxPOI = false
            setTimeout(() => {
              self.infoBoxPOI = true
            }, 100)
          })
          ada[0].poi.push(mark)
        }
      })
    },
    hilangSemuaPOI() {
      let aktif = this.categoryPOI.filter((z) => {
        return z.active_poi == true
      })

      if (aktif.length == 0) {
      } else {
        this.$vs.loading({
          container: '#data-list-list-view',
          scale: 1,
        })
        aktif.forEach((z) => {
          let ada = this.dataPOI

          if (ada[0].poi.length > 0) {
            ada[0].poi.forEach((x) => {
              x.setMap(null)
            })
          }
        })
        setTimeout(() => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        }, 200)
      }
    },
    tampilSemuaPOI() {
      let aktif = this.categoryPOI.filter((z) => {
        return z.active_poi == true
      })
      if (aktif.length == 0) {
        this.map.setOptions({
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'on' }],
            },
          ],
        })
      } else {
        this.$vs.loading({
          container: '#data-list-list-view',
          scale: 1,
        })
        this.map.setOptions({
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
          ],
        })
        aktif.forEach((z) => {
          let ada = this.dataPOI
          if (ada.length > 0)
            this.tampilPOI(ada[0].data, this.baseUrl + z.marker, z.id)
        })
        setTimeout(() => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        }, 200)
      }
    },
    navigateHandler() {
      // this.reff.off();
      // REPO.unsubscribeVehicle(this.id);
    },
    closeHandler(event) {
      // this.reff.off();
      // REPO.unsubscribeVehicle(this.id);
      return 'oke ?'
    },
    startAnimation() {
      // delete marker if it exists
      if (this.marker) {
        this.marker.setMap(null)
      }
      this.eol = this.polyline.Distance()
      this.map.setCenter(this.polyline.getPath().getAt(0))
      this.marker = new google.maps.Marker({
        position: this.polyline.getPath().getAt(0),
        map: this.map,
        icon: this.icon,
      })

      this.animate()
    },
    animate() {
      const self = this
      // this.kmStep = 0
      // let p = this.polyline.GetPointAtDistance(this.kmStep)

      const animateStep = () => {
        const data = self.data_jadi_arr[this.dataIndex]

        if (data) {
          const distance = data.distance
          const duration = data.duration * 5 // Adjust the duration if needed

          const animateSpeed = () => {
            var p = this.polyline.GetPointAtDistance(this.kmStep)
            //
            if (this.kmStep + this.step >= this.eol) {
              this.map.panTo(p)
              this.marker.setPosition(p)
              this.dataIndex++
              // if (this.dataIndex < this.data_jadi_arr.length) {
              //   this.startAnimation()
              // } else {
              //
              this.isMoving = false
              // }
              return
            }
            if (data.speed < 1 && self.isMoving) {
              setTimeout(() => {
                this.map.panTo(p)
                clearTimeout(this.timerHandle)
                animateStep()
              }, 500)
            } else {
              this.step = data.speed
              this.tick = (duration / (distance / this.step)) * this.baseSpeed
              const p = this.polyline.GetPointAtDistance(this.kmStep)
              this.map.panTo(p)
              const lastPosn = this.marker.getPosition()
              this.marker.setPosition(p)
              const heading = google.maps.geometry.spherical.computeHeading(
                lastPosn,
                p
              )
              this.icon.rotation = heading
              this.marker.setIcon(this.icon)
              this.kmStep += this.step
              this.timerHandle = new this.Timer(
                () => {
                  animateSpeed(this.kmStep)
                },
                this.tick,
                this.isMoving
              )
            }
          }

          animateSpeed()
        } else {
          // Animation completed
        }
      }

      // Start the animation
      animateStep()
    },
    Timer(callback, delay, isResume = true) {
      var timerId,
        start,
        remaining = delay

      let pause = function () {
        window.clearTimeout(timerId)
        remaining -= Date.now() - start
      }

      let resume = function () {
        start = Date.now()
        window.clearTimeout(timerId)
        timerId = window.setTimeout(callback, remaining)
      }

      if (isResume) resume()
      else pause()
    },
    initialize(map) {
      //

      this.infowindow = new google.maps.InfoWindow({
        size: new google.maps.Size(150, 50),
      })
      // Instantiate a directions service.
      this.directionsService = new google.maps.DirectionsService()

      // Create a map and center it on Manhattan.
      // var myOptions = {
      //     zoom: 13,
      //     mapTypeId: google.maps.MapTypeId.ROADMAP
      // };
      // map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
      map.setCenter(new google.maps.LatLng(-6.1498619, 106.882887))

      // Create a renderer for directions and bind it to the map.
      var rendererOptions = {
        map: map,
      }
      this.directionsDisplay = new google.maps.DirectionsRenderer(
        rendererOptions
      )

      // Instantiate an info window to hold step text.
      this.stepDisplay = new google.maps.InfoWindow()

      this.polyline = new google.maps.Polyline({
        path: [],
        strokeColor: '#FF0000',
        strokeWeight: 3,
      })
      this.poly2 = new google.maps.Polyline({
        path: [],
        strokeColor: '#FF0000',
        strokeWeight: 3,
      })
      // this.calcRoute(this.location_list[0], this.location_list[0], []);
      // setTimeout(()=>{
      //     this.calcRoute(this.location_list[0], this.location_list[1], []);
      // },5000);
      // setTimeout(()=>{
      //     let tmp=[];
      //     tmp.push(this.location_list[1]);
      //     this.calcRoute(this.location_list[0], this.location_list[2], tmp);
      // },17000)

      // setTimeout(()=>{
      //     this.animate(this.lastStep);
      // },15000)
    },
  },

  mounted() {
    let self = this
    this.id = this.$route.params.id
    this.$vs.loading({
      container: '#data-list-list-view',
      scale: 1,
    })
    self.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map
      setTimeout(() => {
        //
        google.maps.LatLng.prototype.distanceFrom = function (newLatLng) {
          var EarthRadiusMeters = 6378137.0 // meters
          var lat1 = this.lat()
          var lon1 = this.lng()
          var lat2 = newLatLng.lat()
          var lon2 = newLatLng.lng()
          var dLat = ((lat2 - lat1) * Math.PI) / 180
          var dLon = ((lon2 - lon1) * Math.PI) / 180
          var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos((lat1 * Math.PI) / 180) *
              Math.cos((lat2 * Math.PI) / 180) *
              Math.sin(dLon / 2) *
              Math.sin(dLon / 2)
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
          var d = EarthRadiusMeters * c
          return d
        }

        google.maps.LatLng.prototype.latRadians = function () {
          return (this.lat() * Math.PI) / 180
        }

        google.maps.LatLng.prototype.lngRadians = function () {
          return (this.lng() * Math.PI) / 180
        }

        // === A method which returns the length of a path in metres ===
        google.maps.Polygon.prototype.Distance = function () {
          var dist = 0
          for (var i = 1; i < this.getPath().getLength(); i++) {
            dist += this.getPath()
              .getAt(i)
              .distanceFrom(this.getPath().getAt(i - 1))
          }
          return dist
        }

        // === A method which returns a GLatLng of a point a given distance along the path ===
        // === Returns null if the path is shorter than the specified distance ===
        google.maps.Polygon.prototype.GetPointAtDistance = function (metres) {
          // some awkward special cases
          if (metres == 0) return this.getPath().getAt(0)
          if (metres < 0) return null
          if (this.getPath().getLength() < 2) return null
          var dist = 0
          var olddist = 0
          for (
            var i = 1;
            i < this.getPath().getLength() && dist < metres;
            i++
          ) {
            olddist = dist
            dist += this.getPath()
              .getAt(i)
              .distanceFrom(this.getPath().getAt(i - 1))
          }
          if (dist < metres) {
            return null
          }
          var p1 = this.getPath().getAt(i - 2)
          var p2 = this.getPath().getAt(i - 1)
          var m = (metres - olddist) / (dist - olddist)
          return new google.maps.LatLng(
            p1.lat() + (p2.lat() - p1.lat()) * m,
            p1.lng() + (p2.lng() - p1.lng()) * m
          )
        }

        // === A method which returns an array of GLatLngs of points a given interval along the path ===
        google.maps.Polygon.prototype.GetPointsAtDistance = function (metres) {
          var next = metres
          var points = []
          // some awkward special cases
          if (metres <= 0) return points
          var dist = 0
          var olddist = 0
          for (var i = 1; i < this.getPath().getLength(); i++) {
            olddist = dist
            dist += this.getPath()
              .getAt(i)
              .distanceFrom(this.getPath().getAt(i - 1))
            while (dist > next) {
              var p1 = this.getPath().getAt(i - 1)
              var p2 = this.getPath().getAt(i)
              var m = (next - olddist) / (dist - olddist)
              points.push(
                new google.maps.LatLng(
                  p1.lat() + (p2.lat() - p1.lat()) * m,
                  p1.lng() + (p2.lng() - p1.lng()) * m
                )
              )
              next += metres
            }
          }
          return points
        }

        // === A method which returns the Vertex number at a given distance along the path ===
        // === Returns null if the path is shorter than the specified distance ===
        google.maps.Polygon.prototype.GetIndexAtDistance = function (metres) {
          // some awkward special cases
          if (metres == 0) return this.getPath().getAt(0)
          if (metres < 0) return null
          var dist = 0
          var olddist = 0
          for (
            var i = 1;
            i < this.getPath().getLength() && dist < metres;
            i++
          ) {
            olddist = dist
            dist += this.getPath()
              .getAt(i)
              .distanceFrom(this.getPath().getAt(i - 1))
          }
          if (dist < metres) {
            return null
          }
          return i
        }
        // === Copy all the above functions to GPolyline ===
        google.maps.Polyline.prototype.Distance =
          google.maps.Polygon.prototype.Distance
        google.maps.Polyline.prototype.GetPointAtDistance =
          google.maps.Polygon.prototype.GetPointAtDistance
        google.maps.Polyline.prototype.GetPointsAtDistance =
          google.maps.Polygon.prototype.GetPointsAtDistance
        google.maps.Polyline.prototype.GetIndexAtDistance =
          google.maps.Polygon.prototype.GetIndexAtDistance
        self.polyline = new google.maps.Polyline({
          path: [],
          strokeColor: '#78a4ff',
          strokeWeight: 3,
        })
      }, 100)
      self.directionsService = new google.maps.DirectionsService()
      var rendererOptions = {
        polylineOptions: {
          strokeColor: '#78a4ff',
        },
        map: map,
      }
      self.directionsDisplay = new google.maps.DirectionsRenderer(
        rendererOptions
      )

      if (self.googleListener != null) {
        google.maps.event.removeListener(self.googleListener)
      }
      let tmps = google.maps.event.addListener(
        this.map,
        'bounds_changed',
        self.delay(function (e) {
          let bound = self.map.getBounds()
          let coor = bound.toJSON()
          self.data_coordinate = [
            {
              latitude: coor['north'],
              longitude: coor['east'],
            },
            {
              latitude: coor['south'],
              longitude: coor['east'],
            },
            {
              latitude: coor['south'],
              longitude: coor['west'],
            },
            {
              latitude: coor['north'],
              longitude: coor['west'],
            },
          ]
          if (self.current_zoom > 12) {
            if (self.selectedPOICategory != null) {
              let ada = self.dataPOI
              if (ada.length > 0) {
                if (ada[0].poi.length > 0) {
                  ada[0].poi.forEach((x) => {
                    x.setMap(null)
                  })
                }
                ada[0].poi = []
              }
              REPO.getPOIParam({
                coordinates: self.data_coordinate,
                category_poi_id: self.selectedPOICategory.id,
                type: 'General',
              })
                .then((res) => {
                  let tmp = {
                    id: self.selectedPOICategory.id,
                    status: true,
                    poi: [],
                    data: res.data.data,
                  }
                  self.dataPOI = []
                  self.dataPOI.push(tmp)
                  self.tampilPOI(
                    tmp.data,
                    self.selectedPOICategory.marker,
                    self.selectedPOICategory.id
                  )
                  self.$vs.loading.close(
                    '#data-list-list-view > .con-vs-loading'
                  )
                })
                .catch((err) => {
                  self.$vs.loading.close(
                    '#data-list-list-view > .con-vs-loading'
                  )
                })
            }
          } else {
            self.hilangSemuaPOI()
          }
        }, 500)
      )
      self.googleListener = google.maps.event.addListener(
        map,
        'zoom_changed',
        function () {
          // Determines map type and prevent illegal zoom levels
          //
          var zoom = map.getZoom()
          self.current_zoom = zoom
          if (zoom > 12) {
            if (map) {
              self.tampilSemuaPOI()
            }
            self.disableImage = false
          } else {
            if (!self.disableImage) {
              self.hilangSemuaPOI()
            }
            self.disableImage = true
          }
        }
      )

      let data_s = this.data_s
      self.selectedLocation = this.data_s
      self.data_jadi_tmp = {
        anchors: [data_s],
        speed: null,
        duration: null,
      }

      self.data_jadi_arr.push(self.data_jadi_tmp)
      let data_ = {
        lat: data_s.latitude,
        lng: data_s.longitude,
        vehicle_activity: data_s.vehicle_activity,
        direction: data_s.direction,
        speed: data_s.speed,
      }

      let diff_time = moment.duration(moment().diff(data_s.device_time))
      let hours = diff_time.asHours()
      let warna = this.SilenceColor
      if (parseFloat(hours) >= 4 || data_s.vehicle_activity == 'SILENCE') {
        warna = this.SilenceColor
      } else if (data_s.vehicle_activity == 'CRASH') {
        warna = this.CrashColor
      } else if (data_s.vehicle_activity == 'MOVING') {
        warna = this.MovingColor
      } else if (data_s.vehicle_activity == 'IDLE') {
        warna = this.IdleColor
      } else if (data_s.vehicle_activity == 'STOP') {
        warna = this.StopColor
      }
      self.icon = {
        path: self.car,
        scale: 0.7,
        stroke: 'red',
        strokeColor: 'white',
        strokeWeight: 0.1,
        fillOpacity: 1,
        fillColor: warna,
        offset: '5%',
        // rotation: parseInt(heading[i]),
        anchor: new google.maps.Point(10, 25), // kalau 10,50 belakang, 10,0 depan, 10,25 tengah mobil
      }
      self.location_list.push(data_)
      if (self.location_list.length > 0) {
        let panjang = self.location_list.length
        //
        let lokk = new google.maps.LatLng(
          self.location_list[panjang - 1].lat,
          self.location_list[panjang - 1].lng
        )

        self.icon.rotation = self.location_list[panjang - 1].direction
        if (self.marker == null) {
          self.map.setCenter(lokk)
          self.marker = new google.maps.Marker({
            position: lokk,
            map: self.map,
            icon: self.icon,
          })
        } else {
          // self.map.setCenter(lokk);
          self.marker.setPosition(lokk)
          self.icon.rotation = self.location_list[panjang - 1].direction
          self.icon.fillColor = warna
          self.marker.setIcon(self.icon)
        }
      }
      self.dataSubscribe.forEach((poli) => {
        if (poli.type != 'CIRCLE') {
          let poly = []

          let coor = poli.geofence_detail.coordinates[0]
          coor.forEach((x) => {
            let tmp = new google.maps.LatLng(x[1], x[0])
            poly.push(tmp)
          })
          let tmo = new google.maps.Polygon({
            path: poly,
            draggable: false,
            editable: false,
            strokeColor: poli.colour,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: poli.colour,
            fillOpacity: 0.35,
            map: this.map,
          })
          this.polygon.push(tmo)
        } else {
          let coor = poli.geofence_detail.coordinates
          let center = {
            lat: coor[1],
            lng: coor[0],
          }

          let color = '#FF0000'
          if (poli.colour != '') {
            color = poli.colour
          }
          this.drawingManager = new google.maps.Circle({
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: color,
            fillOpacity: 0.35,
            map: this.map,
            center: center,
            radius: poli.radius,
          })
        }
        //  let poly=[];
        // let coor = poli.geofence_detail.coordinates[0];
        //  coor.forEach(x =>{
        //      let tmp = new google.maps.LatLng(x[1], x[0]);
        //      poly.push(tmp)
        //  });
        //  let tmo = new google.maps.Polygon({
        //      path: poly,
        //      draggable: false,
        //      editable: false,
        //      strokeColor: poli.colour,
        //      strokeOpacity: 0.8,
        //      strokeWeight: 2,
        //      fillColor: poli.colour,
        //      fillOpacity: 0.35,
        //      map: map
        //  });
        //  self.polygon.push(tmo);
      })
      self.$vs.loading.close('#data-list-list-view > .con-vs-loading')
      map.setZoom(15)
    })
    
    this.fetchVehiclePosition();

    // Mulai polling posisi kendaraan setiap 5 detik
    this.pollingInterval = setInterval(() => {
      this.fetchVehiclePosition()
    }, 4000)
    // Fetch pertama kali

    this.isMounted = true
  },
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style lang="scss" scoped>
.active-icon {
  box-shadow: 0 0 8px 5px #5cb7f3;
  border-radius: 50%;
}

.poi-icon {
  width: 70%;
  margin: 10px auto;
  cursor: pointer;
}

.disable-img {
  cursor: not-allowed;
  filter: grayscale(100%);
}

.hide-btn {
  position: absolute;
  bottom: -35px;
  left: 4px;
  background: linear-gradient(
    30deg,
    rgb(46, 49, 146) 0%,
    rgb(0, 174, 239) 100%
  );
  border-radius: 50%;
  font-size: 12px;
  color: white;
  width: 30px;
  font-weight: bold;
  cursor: pointer;
  height: 30px;
  padding-left: 11px;
  padding-top: 6px;
  box-shadow: 2px 3px 4px dimgrey;
}

.collapse {
  height: 38px;
  overflow-y: hidden;
  transition: 1s;
}

.pick-category {
  position: absolute;
  border-radius: 25px;
  top: 60px;
  left: 10px;
  width: 38px;
  box-shadow: 2px 3px 3px rgba(103, 103, 103, 0.47);
  z-index: 2;
  background: rgba(255, 255, 255, 0.39);
}

.window-monitoring {
  box-shadow: #0000005c 1px 0px 6px;
  padding: 18px 0;
  position: absolute;
  z-index: 3;
  background: white;
  font-size: 12px;
}

.heights {
  width: 100%;
  height: calc(100vh - 15.5rem);
}
</style>
